export default function Second() {
    return (
        <div>
            <h1>Second Page!</h1>
        </div>
    );
}
